<template>
  <div>
    <v-banner
      sticky
      color="background"
    >
      <div class="d-flex flex-row justify-space-between">
        <span class="text-h6">Confirm transaction</span>
        <div class="ml-2">
          <span class="text-caption">Valid for: </span> <br />
          <CountdownTimer
            :endDate="expirationTime"
            @endTime="valid = false"
            typography="font-weight-bold text-body-1"
          />
        </div>
      </div>
    </v-banner>
    <v-row>
      <v-col align="left">
        <v-card
          rounded
          color="cardIsland"
          class="mx-auto my-12"
          max-width="374"
        >
          <v-card-title
            v-if="!valid"
            class="text-h6 font-weight-bold"
          >
            <v-icon style="color:#FF5050">mdi-alert</v-icon>&nbsp;Invalid
          </v-card-title>
          <v-card-text>
            <div v-if="valid">
              <OrderDetails
                :orderType="orderType"
                :isReceipt="false"
              />
              <div class="d-flex flex-row justify-space-between">
                <v-btn
                  @click="createOrder"
                  class="mt-4"
                  block
                  color="primary"
                  :loading="isLoading"
                >Create {{orderType}} order &rightarrow;</v-btn>
              </div>
              <div
                v-if="valid"
                class="mt-2"
              >
                Upon clicking through, you will have 5 minutes to make your payment.
                <span v-if="orderType === 'buy'">We use PayID as our payment option so please have your details ready.</span>
                <span v-if="orderType === 'sell'">We'll ask you to make a payment to our wallet address so please have your wallet details ready.</span>
              </div>
            </div>
            <div v-if="!valid">
              Sorry, this transaction is no longer valid. Either the time has run out or the price fluctuated more than 2%.
              <a
                @click="$emit('neworder')"
                class="text-decoration-underline"
                style="color:#0177FB"
              >Create a new {{orderType}} order here instead.</a>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import OrderDetails from "../OrderDetails.vue"
import CountdownTimer from "../CountdownTimer.vue"

export default {
  props: ["orderType"],
  components: {
    OrderDetails,
    CountdownTimer,
  },
  data() {
    return {
      isLoading: false,
      valid: true,
      expirationTime: null,
    }
  },
  computed: {
    ...mapState('order', ['order']),
    ...mapState("auth", ["accessToken"]),
    currentTime() {
      return new Date()
    }
  },
  methods: {
    ...mapMutations('order', ['setOrder']),
    ...mapActions("auth", ["getAccessToken"]),
    getExpirationTime(startTime, minutesToAdd) {
      return new Date(startTime.getTime() + minutesToAdd * 60000);
    },
    async createOrder() {
      this.isLoading = true
      try {
        const id = this.order.id
        await this.getAccessToken()
        const response = await fetch(`${process.env.VUE_APP_API_URL}/orders/${id}`, {
          method: 'PUT',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.accessToken}`,
          },
        })
        const data = await response.json()
        if (!data.valid) this.valid = false
        if (data.valid) {
          this.setOrder(data.order)
          this.$router.push({ path: `/order/${this.orderType}/${id}` })
        }
      } catch (error) {
        console.log(error)
      }
      this.isLoading = false
    },
  },
  mounted() {
    const orderCreatedAt = new Date(JSON.parse(this.order.createdAt))
    // const orderCreatedAt = new Date(this.order.createdAt)
    this.expirationTime = this.getExpirationTime(orderCreatedAt, 1)
  },
}
</script>

<style>
</style>